module.exports = "https://bin.bnbstatic.com/_next/static/images/app-44cc2a9c638f76d97c77415b9c6303c2.png";